import React, { useMemo, useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useUserInfo } from '@/hooks'
import { toFixedNoRound, formatThousands } from '@/utils'
import { Toast } from 'react-vant'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import LogoTitle from '@/components/logoTitle'
import Ripple from '@/components/Ripple'

export default React.memo(function Account() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { userInfo, actions: userActions } = useUserInfo()

  // 页面加载时刷新用户信息
  useEffect(() => {
    userActions.refreshUserInfo()
  }, [])
  const navigateToTransactionHistory = useCallback((item: any) => {
    if (item.noLine) return Toast.info(t('即将上线'))
    navigate('/account/transaction-history', {
      state: {
        coinName: item.name
      }
    })
  }, [navigate])
  const items = useMemo(
    () => ([
      {
        label: t('加密货币账户'),
        items: [
          { icon: `/images/home/usdt.png`, name: 'USDT', balance: userInfo?.usdt, usd: `≈ ${formatThousands(userInfo?.usdt, 2, true)} USD` },
          { icon: `/images/home/usdc.png`, name: 'USDC', balance: userInfo?.usdc, usd: `≈ ${formatThousands(userInfo?.usdc, 2, true)} USD` },
          { icon: `/images/home/usd1.png`, name: 'USD1', balance: userInfo?.usd1, usd: `≈ ${formatThousands(userInfo?.usd1, 2, true)} USD` },
        ]
      },
      {
        label: t('法币账户'),
        items: [
          { icon: `/images/home/usd.png`, name: 'USD', balance: userInfo?.usd, usd: `≈ ${formatThousands(userInfo?.usd, 2, true)} USD` },
          { icon: `/images/home/eur.png`, name: 'EUR', balance: '0.00', usd: '≈ 0.00 USD' },
          { icon: `/images/home/gbp.png`, name: 'GBP', balance: '0.00', usd: '≈ 0.00 USD' },
        ]
      },
    ]),
    [userInfo, t]
  )

  const Items = useMemo(
    () => items.map((item, index) => (

      <div key={index} className="mb-6">
        <div className="text-base font-medium text-[#1A1A1A] mb-3">{item.label}</div>
        <div className="bg-white rounded-lg space-y-2.5">
          {item.items.map((_item, _index) => (
            <Ripple key={_index} className="rounded-2xl">
              <div
                key={_index}
                onClick={() => navigateToTransactionHistory(_item)}
                className="w-full flex items-center bg-white border-[0.5px] border-solid border-[#000000]/7 justify-between px-4 min-h-15  rounded-2xl"
              >
                <div className="flex items-center">
                  <div className="w-6 h-6 mr-2 rounded-full overflow-hidden flex items-center justify-center">
                    <img className='w-full h-full object-cover' src={_item.icon} alt={_item.name} />
                  </div>
                  <div className="text-sm font-medium text-[#1A1A1A]/65 flex items-center">{_item.name}</div>
                </div>
                <div className="text-right">
                  <div className="font-semibold text-base text-black">{formatThousands(_item.balance, 2, true)}</div>
                  <div className="text-xs text-[#1A1A1A]/60">{_item.usd}</div>
                </div>
              </div>
            </Ripple>
          ))}
        </div>
      </div >

    )),
    [navigate, items]
  )

  return (
    <PageLayout tabbarPage={true}>
      <Header
        leftChildren={
          <Ripple className='rounded-full'>
            <div className='w-10 h-10 bg-[#E4E4E4]/50 flex items-center justify-center rounded-full' onClick={() => navigate('/my')}>
              <img src="/icon/user-icon.svg" alt="User Icon" />
            </div>
          </Ripple>
        }
        centerChildren={<LogoTitle />}
        rightChildren={
          <Ripple className='rounded-full'>
            <div className='w-10 h-10 bg-[var(--primary-color)] flex items-center justify-center rounded-full' onClick={() => navigate('/message')}>
              <img src="/icon/message-icon.svg" alt="Logo" />
            </div>
          </Ripple>
        }
      />
      <div className="px-6 py-6">
        {/* Assets */}
        <div className="bg-white pb-4">
          <div className="text-base text-[#1A1A1A]/50 ">{t('我的资产USD')}</div>
          <div className="text-8.75 font-bold text-black my-1">{formatThousands(userInfo?.balance, 2, true)}</div>
          <div className="text-sm  text-[#808080]">≈ {formatThousands(userInfo?.balance, 2, true)} USD</div>
        </div>
        {Items}
      </div>
    </PageLayout>
  )
})